unit View.Plano_Contas_Contabil.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewPlano_Contas_ContabilList = class(TForm)
    btNew: TButton;
    Plano_Contas_ContabilDataset: TXDataWebDataSet;
    Plano_Contas_ContabilDatasetid: TIntegerField;
    Plano_Contas_ContabilDatasetaliado_id: TIntegerField;
    Plano_Contas_ContabilDatasetdata_base_id: TIntegerField;
    Plano_Contas_ContabilDatasetnome: TStringField;
    Plano_Contas_ContabilDatasetnivel: TStringField;
    Plano_Contas_ContabilDatasettipo: TStringField;
    Plano_Contas_ContabilDatasetcodigo_interno: TIntegerField;
    Plano_Contas_ContabilDatasetexcluido: TBooleanField;
    Plano_Contas_ContabilDatasetinclusao: TDateTimeField;
    Plano_Contas_ContabilDatasetalteracao: TDateTimeField;
    Plano_Contas_ContabilDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewPlano_Contas_ContabilList: TFViewPlano_Contas_ContabilList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewPlano_Contas_ContabilList }

procedure TFViewPlano_Contas_ContabilList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewPlano_Contas_ContabilList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewPlano_Contas_ContabilList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewPlano_Contas_ContabilList, AElementID, Result, @AfterCreate);
end;

procedure TFViewPlano_Contas_ContabilList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewPlano_Contas_ContabilList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewPlano_Contas_ContabilList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Plano_Contas_ContabilDataset.Connection.Model.DefaultSchema.FindEntityType(Plano_Contas_ContabilDataset.EntitySetName),
      Plano_Contas_ContabilDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewPlano_Contas_ContabilList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('plano_contas_contabil', 'active');
  TUtils.SetValorDicionarioClasses('cadastros_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_cadastros', 'active');
  TUtils.SetValorDicionarioClasses('plano_contas_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_plano_contas', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Plano_Contas_ContabilDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewPlano_Contas_ContabilList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.plano_contas_contabil.list.pagination.info');
  btNew := TButton.Create('view.plano_contas_contabil.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.plano_contas_contabil.list.table');
  cbPageSize := TComboBox.Create('view.plano_contas_contabil.list.cbPageSize');
  edSearch := TEdit.Create('view.plano_contas_contabil.list.search');
  lcPaginator := TListControl.Create('view.plano_contas_contabil.list.pagination');
  Plano_Contas_ContabilDataset := TXDataWebDataSet.Create(Self);
  Plano_Contas_ContabilDatasetid := TIntegerField.Create(Self);
  Plano_Contas_ContabilDatasetaliado_id := TIntegerField.Create(Self);
  Plano_Contas_ContabilDatasetdata_base_id := TIntegerField.Create(Self);
  Plano_Contas_ContabilDatasetnome := TStringField.Create(Self);
  Plano_Contas_ContabilDatasetnivel := TStringField.Create(Self);
  Plano_Contas_ContabilDatasettipo := TStringField.Create(Self);
  Plano_Contas_ContabilDatasetcodigo_interno := TIntegerField.Create(Self);
  Plano_Contas_ContabilDatasetexcluido := TBooleanField.Create(Self);
  Plano_Contas_ContabilDatasetinclusao := TDateTimeField.Create(Self);
  Plano_Contas_ContabilDatasetalteracao := TDateTimeField.Create(Self);
  Plano_Contas_ContabilDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Plano_Contas_ContabilDataset.BeforeLoadDFMValues;
  Plano_Contas_ContabilDatasetid.BeforeLoadDFMValues;
  Plano_Contas_ContabilDatasetaliado_id.BeforeLoadDFMValues;
  Plano_Contas_ContabilDatasetdata_base_id.BeforeLoadDFMValues;
  Plano_Contas_ContabilDatasetnome.BeforeLoadDFMValues;
  Plano_Contas_ContabilDatasetnivel.BeforeLoadDFMValues;
  Plano_Contas_ContabilDatasettipo.BeforeLoadDFMValues;
  Plano_Contas_ContabilDatasetcodigo_interno.BeforeLoadDFMValues;
  Plano_Contas_ContabilDatasetexcluido.BeforeLoadDFMValues;
  Plano_Contas_ContabilDatasetinclusao.BeforeLoadDFMValues;
  Plano_Contas_ContabilDatasetalteracao.BeforeLoadDFMValues;
  Plano_Contas_ContabilDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewPlano_Contas_ContabilList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nivel';
      Title := 'nivel';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'tipo';
      Title := 'tipo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Plano_Contas_ContabilDataset.SetParentComponent(Self);
    Plano_Contas_ContabilDataset.Name := 'Plano_Contas_ContabilDataset';
    Plano_Contas_ContabilDataset.EntitySetName := 'Plano_Contas_Contabil';
    Plano_Contas_ContabilDataset.Connection := DMConnection.ApiConnection;
    Plano_Contas_ContabilDataset.Left := 72;
    Plano_Contas_ContabilDataset.Top := 144;
    Plano_Contas_ContabilDatasetid.SetParentComponent(Plano_Contas_ContabilDataset);
    Plano_Contas_ContabilDatasetid.Name := 'Plano_Contas_ContabilDatasetid';
    Plano_Contas_ContabilDatasetid.FieldName := 'id';
    Plano_Contas_ContabilDatasetid.Required := True;
    Plano_Contas_ContabilDatasetaliado_id.SetParentComponent(Plano_Contas_ContabilDataset);
    Plano_Contas_ContabilDatasetaliado_id.Name := 'Plano_Contas_ContabilDatasetaliado_id';
    Plano_Contas_ContabilDatasetaliado_id.FieldName := 'aliado_id';
    Plano_Contas_ContabilDatasetaliado_id.Required := True;
    Plano_Contas_ContabilDatasetdata_base_id.SetParentComponent(Plano_Contas_ContabilDataset);
    Plano_Contas_ContabilDatasetdata_base_id.Name := 'Plano_Contas_ContabilDatasetdata_base_id';
    Plano_Contas_ContabilDatasetdata_base_id.FieldName := 'data_base_id';
    Plano_Contas_ContabilDatasetdata_base_id.Required := True;
    Plano_Contas_ContabilDatasetnome.SetParentComponent(Plano_Contas_ContabilDataset);
    Plano_Contas_ContabilDatasetnome.Name := 'Plano_Contas_ContabilDatasetnome';
    Plano_Contas_ContabilDatasetnome.FieldName := 'nome';
    Plano_Contas_ContabilDatasetnome.Required := True;
    Plano_Contas_ContabilDatasetnome.Size := 255;
    Plano_Contas_ContabilDatasetnivel.SetParentComponent(Plano_Contas_ContabilDataset);
    Plano_Contas_ContabilDatasetnivel.Name := 'Plano_Contas_ContabilDatasetnivel';
    Plano_Contas_ContabilDatasetnivel.FieldName := 'nivel';
    Plano_Contas_ContabilDatasetnivel.Required := True;
    Plano_Contas_ContabilDatasetnivel.Size := 255;
    Plano_Contas_ContabilDatasettipo.SetParentComponent(Plano_Contas_ContabilDataset);
    Plano_Contas_ContabilDatasettipo.Name := 'Plano_Contas_ContabilDatasettipo';
    Plano_Contas_ContabilDatasettipo.FieldName := 'tipo';
    Plano_Contas_ContabilDatasettipo.Required := True;
    Plano_Contas_ContabilDatasettipo.Size := 255;
    Plano_Contas_ContabilDatasetcodigo_interno.SetParentComponent(Plano_Contas_ContabilDataset);
    Plano_Contas_ContabilDatasetcodigo_interno.Name := 'Plano_Contas_ContabilDatasetcodigo_interno';
    Plano_Contas_ContabilDatasetcodigo_interno.FieldName := 'codigo_interno';
    Plano_Contas_ContabilDatasetcodigo_interno.Required := True;
    Plano_Contas_ContabilDatasetexcluido.SetParentComponent(Plano_Contas_ContabilDataset);
    Plano_Contas_ContabilDatasetexcluido.Name := 'Plano_Contas_ContabilDatasetexcluido';
    Plano_Contas_ContabilDatasetexcluido.FieldName := 'excluido';
    Plano_Contas_ContabilDatasetinclusao.SetParentComponent(Plano_Contas_ContabilDataset);
    Plano_Contas_ContabilDatasetinclusao.Name := 'Plano_Contas_ContabilDatasetinclusao';
    Plano_Contas_ContabilDatasetinclusao.FieldName := 'inclusao';
    Plano_Contas_ContabilDatasetalteracao.SetParentComponent(Plano_Contas_ContabilDataset);
    Plano_Contas_ContabilDatasetalteracao.Name := 'Plano_Contas_ContabilDatasetalteracao';
    Plano_Contas_ContabilDatasetalteracao.FieldName := 'alteracao';
    Plano_Contas_ContabilDatasetexclusao.SetParentComponent(Plano_Contas_ContabilDataset);
    Plano_Contas_ContabilDatasetexclusao.Name := 'Plano_Contas_ContabilDatasetexclusao';
    Plano_Contas_ContabilDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Plano_Contas_ContabilDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Plano_Contas_ContabilDataset.AfterLoadDFMValues;
    Plano_Contas_ContabilDatasetid.AfterLoadDFMValues;
    Plano_Contas_ContabilDatasetaliado_id.AfterLoadDFMValues;
    Plano_Contas_ContabilDatasetdata_base_id.AfterLoadDFMValues;
    Plano_Contas_ContabilDatasetnome.AfterLoadDFMValues;
    Plano_Contas_ContabilDatasetnivel.AfterLoadDFMValues;
    Plano_Contas_ContabilDatasettipo.AfterLoadDFMValues;
    Plano_Contas_ContabilDatasetcodigo_interno.AfterLoadDFMValues;
    Plano_Contas_ContabilDatasetexcluido.AfterLoadDFMValues;
    Plano_Contas_ContabilDatasetinclusao.AfterLoadDFMValues;
    Plano_Contas_ContabilDatasetalteracao.AfterLoadDFMValues;
    Plano_Contas_ContabilDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
